@if (isHovered$ | async; as isHovered) {
    @if (isHovered === true) {
        <div class="shop-info">
            <button (click)="shopLocatorFacade.unsetHoveredShop()" class="close-btn">
                <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.close_tray"> Close </span>
                <h-svg-icon class="cross-icon" [name]="'cross'"></h-svg-icon>
            </button>
            @if (shopStream$ | async; as stream) {
                <h-shop-info
                    class="infos"
                    [shop]="stream.shop"
                    [linkMode]="linkMode"
                    [headerLevelShopTitle]="2"
                    [directionLinkMode]="stream.directionLinkMode"
                    [directionUrl]="stream.directionUrl"
                    [meters]="stream.meters"
                    [sectionsToDisplay]="sectionsToDisplay"
                    (shopInfoEvents)="shopInfoEvents.emit({ event: $event, shopIndex: 1, shop: stream.shop })">
                </h-shop-info>
            }
        </div>
    }
    @if (isHovered === true) {
        <div class="infos-background" (click)="shopLocatorFacade.unsetHoveredShop()"></div>
    }
}
